<wd-input-container [name]="name" [classes]="classes()" [label]="label" [helpText]="helpText()" [comments]="comments" [hideComments]="hideComments">
	<textarea
		[name]="'input' + name"
		type="text"
		class="form-control"
		[(ngModel)]="model"
		#inputValue="ngModel"
		[ngClass]="classes()"
		(mousedown)="onMouseDown($event)"
		(focus)="onFocus($event)"
		(focusout)="onFocusOut()"
		(ngModelChange)="onChange()"
		[rows]="numberOfRows()"
		[readonly]="disabled()"
		[attr.tabindex]="disabled() ? -1 : 0"
		(click)="onClick($event)"
	>
	</textarea>
</wd-input-container>
